export default {
  TOKEN_KEY: process.env.TOKEN_KEY,
  API_ENDPOINT:
    process.env.REACT_APP_API_ENDPOINT ||
    'https://immense-bayou-75450.herokuapp.com/api',
};
